<script>
    import {onMount, afterUpdate} from "svelte";
    import {getEndLabel, getStartLabel, mainTimeline} from "../timelines/main-timeline";
    import gsap from "gsap";
    import isMobile from "../helpers/isMobile";

    export let audioMuted = false;

    const voiceOverFiles = [
        "audio/longitude-voiceover_01.mp3",
        "audio/longitude-voiceover_02.mp3",
        "audio/longitude-voiceover_03.mp3",
        "audio/longitude-voiceover_04.mp3",
        "audio/longitude-voiceover_05.mp3",
        "audio/longitude-voiceover_06.mp3",
        "audio/longitude-voiceover_07.mp3",
        "audio/longitude-voiceover_08.mp3",
        "audio/longitude-voiceover_09.mp3",
        "audio/longitude-voiceover_10.mp3",
        "audio/longitude-voiceover_11.mp3",
    ];

    let backingTrackElement;

    const backingTrack = "audio/journey-soundtrack.mp3";

    function getAudioElement(i) {
        return document.getElementById("audio" + i);
    }

    function getAllAudioElements(audioFiles) {
        return audioFiles.map((_, i) => getAudioElement(i))
    }

    function playFile(selector) {

        const allElements = getAllAudioElements(voiceOverFiles);

        allElements.forEach(el => el.pause());

        if (!!selector) {
            gsap.to(selector, {
                volume: volume,
                duration: 0.001,
                onComplete: () => {
                    selector.currentTime = 0;
                    selector.play();
                },
            })
        }
    }

    function pauseFile(selector) {
        if (!!selector) {
            gsap.to(selector, {
                volume: 0,
                duration: 0.3,
                onComplete: () => selector.pause(),
            })
        }
    }

    const timeline = gsap.timeline();

    $: volume = audioMuted ? 0 : 1;

    afterUpdate(() => {
        [backingTrackElement, ...getAllAudioElements(voiceOverFiles)].forEach(el => {
            gsap.to(el, {
                volume: volume,
                duration: 0.001,
            });
        });
    });

    onMount(() => {
        voiceOverFiles.forEach((fileName, i) => {
            const el = getAudioElement(i);
            mainTimeline.call(playFile, [el], getStartLabel(i + 3));
            mainTimeline.call(pauseFile, [el], getEndLabel(i + 3) + '+= 0.1');
        });

        mainTimeline.call(playFile, [backingTrackElement], 'planetsEnd');
    });
</script>

{#if !isMobile()}
    {#each voiceOverFiles as file, i}
        <audio src={file} id="{'audio' + i}"></audio>
    {/each}

    <audio
        src={backingTrack}
        bind:this={backingTrackElement}
        id="backing-track"
        loop
    ></audio>
{/if}